import SimulateService from "../../../../../../service/SimulateService";
import { HwilComponentType } from "../../../../types";

export const exportSchedule = (
    missionId: string,
    scenarioId: string
): Promise<{ success: boolean; message: string }> => {
    return new Promise((resolve, reject) => {
        const button = document.querySelector('.generated__assets_inner__button') as HTMLButtonElement;
        button.disabled = true;

        SimulateService.exportSchedule(missionId, scenarioId)
            ?.then((res) => {
                if (res?.data?.data) {
                    const lines: string[] = res.data.data.map((command: any) => {
                        return '\n' + JSON.stringify(command);
                    });

                    const payload = lines.join(',');

                    const blob = new Blob([payload], { type: 'application/json' });
                    const url = window.URL.createObjectURL(blob);

                    const a = document.createElement('a');
                    a.href = url;
                    a.download = 'schedule.json';
                    document.body.appendChild(a);
                    a.click();

                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);

                    const message = res.data.message || 'Schedule exported successfully';

                    resolve({
                        success: true,
                        message,
                    });
                } else {
                    const message = res?.data?.message || 'No scheduled tasks to export';
                    reject({
                        success: false,
                        message,
                    });
                }
            })
            .catch(() => {
                reject({
                    success: false,
                    message: 'Schedule export failed',
                });
            })
            .finally(() => {
                button.disabled = false;
            });
    });
};


export const downloadHwilAsset = async (
    file: HwilComponentType,
    missionId: string,
    scenarioId: string
): Promise<{ success: boolean; message: string }> => {
    return new Promise(async (resolve, reject) => {
        const credentials = sessionStorage.getItem("authentication");
        const fileId: string = file.uniqueId;
        const button = document.querySelector('.generated__assets_inner__button') as HTMLButtonElement;

        button.disabled = true;

        try {
            const response = SimulateService.downloadHwilConfigFile(
                missionId,
                scenarioId,
                fileId,
                credentials
            );

            // If API returns the file URL:
            window.location.href = response;

            resolve({
                success: true,
                message: 'Asset downloaded successfully'
            });

        } catch (error) {
            reject({
                success: false,
                message: 'Failed to download asset'
            });
        } finally {
            button.disabled = false;
        }
    });
};
